<div class="footer">
  <subscribe class="subscribe-panel"></subscribe>


  <div class="footer-info ">
    <div class="info footer-item">
      <div class="footer-header">Наш магазин</div>

      <div >
        <a href="{{addressLink}}" target="_blank">
          <div class="text-info" [innerHTML] = "shopInfo"> </div>

        </a>
      </div>
      <div>
        <a href="{{emailLink}}">{{email}}</a>
      </div>

    </div>
    <div class="footer-menu footer-item">
      <div class="footer-header">VARЁNKA</div>
      <div class="footer-menu-item" routerLinkActive="active" (click)="navigate('/delivery-info')">Доставка</div>
      <div class="footer-menu-item" routerLinkActive="active" (click)="navigate('/info')">О нас</div>
      <div class="footer-menu-item" routerLinkActive="active" (click)="navigate('/privacy-policy')">Политика
        конфиденциальности
      </div>
      <div class="footer-menu-item" routerLinkActive="active" (click)="navigate('/customer-agreement')">Пользовательское
        соглашение
      </div>
      <div class="footer-menu-item" routerLinkActive="active" (click)="navigate('/product-back-info')">Условия возврата</div>
      <div class="footer-menu-item" routerLinkActive="active" (click)="navigate('/contacts')">Контакты</div>
      <a *ngIf="showReclamation" href="{{reclamationLinc}}" class="footer-menu-item" target="_blank">{{reclamationInfo}}</a>


    </div>
    <div class="footer-item">
      <div class="text-info" [innerHTML] = "ownerinfo"> </div>



      <div class="media-links">
        <a href="{{instagram}}" target="_blank">
          <img src="../../../assets/icons/instagram.png" class="media-icon" >
        </a>
        <a href="{{telegram}}" target="_blank">
          <img src="../../../assets/icons/telegram.png" class="media-icon">
        </a>
      </div>
    </div>
  </div>

</div>
